<template>
  <div class="bind-idcard-page">
    <van-nav-bar title="绑定身份证" left-arrow @click-left="onClickLeft" />
    
    <div class="tips-box" v-if="!isBindDoctor">
      <van-icon name="info-o" color="#1989fa" />
      <span>请输入您的身份证号进行医生身份验证，身份证号必须是后台已维护的医生信息</span>
    </div>
    
    <div class="tips-box success" v-else>
      <van-icon name="passed" color="#07c160" />
      <span>您已绑定医生身份</span>
    </div>
    
    <van-cell-group class="form-group">
      <van-field
        v-model="form.idCard"
        label="身份证号"
        placeholder="请输入身份证号"
        :disabled="isBindDoctor"
        :error-message="errors.idCard"
      />
    </van-cell-group>
    
    <div class="submit-btn" v-if="!isBindDoctor">
      <van-button type="primary" block :loading="loading" @click="submit">确认绑定</van-button>
    </div>
    
    <div class="doctor-info" v-if="isBindDoctor && doctorInfo.doctorId">
      <van-cell-group>
        <van-cell title="医生姓名" :value="doctorInfo.doctorName" />
        <van-cell title="科室" :value="doctorInfo.department" />
        <van-cell title="职称" :value="doctorInfo.title" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoctorBindIdCard',
  data() {
    return {
      form: {
        idCard: ''
      },
      errors: {
        idCard: ''
      },
      loading: false,
      isBindDoctor: false,
      doctorInfo: {}
    }
  },
  created() {
    this.checkDoctorBind();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    checkDoctorBind() {
      var user = this.$tool.getDoctorUser();
      if (user && user.userId) {
        if (user.isBindDoctor && user.doctorInfo) {
          this.isBindDoctor = true;
          this.doctorInfo = user.doctorInfo;
          this.form.idCard = user.doctorInfo.idCard || '';
        }
      } else {
        this.$toast.fail('请先登录');
        this.$router.replace('/doctor/index');
      }
    },
    validate() {
      var valid = true;
      this.errors = { idCard: '' };
      
      if (!this.form.idCard.trim()) {
        this.errors.idCard = '请输入身份证号';
        valid = false;
      } else if (!this.$tool.identityCodeValid3(this.form.idCard.trim().toUpperCase())) {
        this.errors.idCard = '请输入正确的身份证号';
        valid = false;
      }
      
      return valid;
    },
    submit() {
      if (!this.validate()) {
        return;
      }
      
      var user = this.$tool.getDoctorUser();
      if (!user || !user.userId) {
        this.$toast.fail('请先登录');
        return;
      }
      
      this.loading = true;
      this.form.idCard = this.form.idCard.toUpperCase();
      
      this.$http.post(this.$Api.doctorBindDoctor, {
        userId: user.userId,
        idCard: this.form.idCard
      }).then(res => {
        this.loading = false;
        if (res.data.code === 200) {
          this.$toast.success('绑定成功');
          this.doctorInfo = res.data.data;
          this.isBindDoctor = true;
          this.$tool.setDoctorUser({
            userId: user.userId,
            openid: user.openid,
            isBindDoctor: true,
            doctorInfo: res.data.data
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          this.$toast.fail(res.data.msg || '绑定失败，请确认身份证号是否为后台已维护的医生');
        }
      }).catch(() => {
        this.loading = false;
        this.$toast.fail('网络错误，请重试');
      });
    }
  }
}
</script>

<style scoped>
.bind-idcard-page {
  background: #f5f5f5;
  min-height: 100vh;
}
.tips-box {
  padding: 16px;
  color: #1989fa;
  font-size: 14px;
  display: flex;
  align-items: center;
  background: #e8f4ff;
}
.tips-box.success {
  color: #07c160;
  background: #e8f8e8;
}
.tips-box .van-icon {
  margin-right: 8px;
  font-size: 18px;
}
.form-group {
  margin-top: 10px;
}
.submit-btn {
  padding: 20px 16px;
}
.doctor-info {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/doctor/bindIdCard.vue